import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, X, ArrowRight } from 'lucide-react';

interface UpgradeBannerProps {
  onDismiss: () => void;
}

const UpgradeBanner: React.FC<UpgradeBannerProps> = ({ onDismiss }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    navigate('/pricing');
  };

  return (
    <div className="relative mb-6 rounded-xl bg-gradient-to-r from-indigo-600 via-indigo-700 to-purple-600 dark:from-indigo-700 dark:via-indigo-800 dark:to-purple-700 p-4 sm:p-5 shadow-lg overflow-hidden animate-in fade-in slide-in-from-top-2 duration-300">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-2xl" />
        <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-purple-400/20 rounded-full blur-2xl" />
      </div>

      {/* Close button */}
      <button
        onClick={onDismiss}
        className="absolute top-3 right-3 p-1.5 rounded-lg text-white/70 hover:text-white hover:bg-white/10 transition-colors"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>

      {/* Content */}
      <div className="relative flex flex-col sm:flex-row items-start sm:items-center gap-4">
        {/* Icon */}
        <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-white/20 flex items-center justify-center">
          <Sparkles className="h-5 w-5 text-white" />
        </div>

        {/* Text */}
        <div className="flex-1 min-w-0 pr-6 sm:pr-0">
          <h3 className="text-white font-semibold text-base sm:text-lg">
            Upgrade for more transcription time and premium features
          </h3>
          <p className="text-white/70 text-sm mt-0.5">
            Get higher limits, priority processing, and advanced exports
          </p>
        </div>

        {/* CTA Button */}
        <button
          onClick={handleUpgrade}
          className="flex-shrink-0 inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-white hover:bg-slate-50 text-indigo-700 font-semibold text-sm shadow-sm transition-colors"
        >
          Upgrade Now
          <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default UpgradeBanner;
